import merge from 'lodash/merge'

// OMS translation files
import fr from './fr.json'
import en from './en.json'
import zh from './zh.json'
import de from './de.json'
import ja from './ja.json'
import ko from './ko.json'
import es from './es.json'
import it from './it.json'

//Vee validate translation files
import frVeeValidate from 'vee-validate/dist/locale/fr.json'
import enVeeValidate from 'vee-validate/dist/locale/en.json'
import zhVeeValidate from 'vee-validate/dist/locale/zh_CN.json'
import deVeeValidate from 'vee-validate/dist/locale/de.json'
import jaVeeValidate from 'vee-validate/dist/locale/ja.json'
import koVeeValidate from 'vee-validate/dist/locale/ko.json'
import esVeeValidate from 'vee-validate/dist/locale/es.json'
import itVeeValidate from 'vee-validate/dist/locale/it.json'

//vuetify translation files
import frVuetify from 'vuetify/es5/locale/fr'
import enVuetify from 'vuetify/es5/locale/en'
import zhVuetify from 'vuetify/es5/locale/zh-Hans'
import deVuetify from 'vuetify/es5/locale/de'
import jaVuetify from 'vuetify/es5/locale/ja'
import koVuetify from 'vuetify/es5/locale/ko'
import esVuetify from 'vuetify/es5/locale/es'
import itVuetify from 'vuetify/es5/locale/it'

const buildLocale = (messages, veeMessages, vuetifyMessages) =>
  merge({ validation: veeMessages.messages, $vuetify: vuetifyMessages }, messages)

export default {
  fr: buildLocale(fr, frVeeValidate, frVuetify),
  en: buildLocale(en, enVeeValidate, enVuetify),
  zh: buildLocale(zh, zhVeeValidate, zhVuetify),
  de: buildLocale(de, deVeeValidate, deVuetify),
  ja: buildLocale(ja, jaVeeValidate, jaVuetify),
  ko: buildLocale(ko, koVeeValidate, koVuetify),
  es: buildLocale(es, esVeeValidate, esVuetify),
  it: buildLocale(it, itVeeValidate, itVuetify),
}
